// extracted by mini-css-extract-plugin
module.exports = {"sectorsGrid":"SectorsLanding_sectorsGrid__3LXxS"};